import React from "react";

const MAX_DB = 30;

const BassBoost = ({ bassBoost, handleBassBoostChange, styles }) => {
  const sliderValue = (bassBoost / MAX_DB) * 100;
  const displayValue = Math.round(sliderValue);

  const handleChange = (e) => {
    const db = (parseFloat(e.target.value) / 100) * MAX_DB;
    handleBassBoostChange(db);
  };

  return (
    <div className={styles.effectRow}>
      <div className={styles.effectMeta}>
        <span className={styles.effectLabel}>Bass</span>
        <span className={styles.effectValue}>
          <input
            type="text"
            className={styles.effectInput}
            defaultValue={displayValue}
            key={`bass-${displayValue}`}
            onFocus={(e) => e.target.select()}
            onBlur={(e) => {
              const v = parseFloat(e.target.value);
              if (!isNaN(v)) {
                const clamped = Math.min(100, Math.max(0, v));
                const db = (clamped / 100) * MAX_DB;
                handleBassBoostChange(db);
              }
            }}
            onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
          />
        </span>
      </div>
      <div className={styles.sliderWrap}>
        <div className={styles.sliderTrack}>
          <div className={styles.sliderFill} style={{ width: `${sliderValue}%` }} />
        </div>
        <input
          type="range"
          min="0"
          max="100"
          step="0.1"
          value={sliderValue}
          onChange={handleChange}
          onDoubleClick={() => handleBassBoostChange(0)}
          className={styles.sliderInput}
        />
        <div className={styles.sliderKnob} style={{ left: `${sliderValue}%` }} />
      </div>
    </div>
  );
};

export default BassBoost;
